import { properties } from "@repoflow/common/schema-fields";
import {
  domainId, domain, status, description, publicKey, privateKey, orgId,
  webhookRoute,
  webhookSecret
} from "./fields";

export default [
  {
    id: "/Public/Domain",
    type: "object",
    properties: {
      ...properties,
      domainId,
      domain,
      status,
      description,
      publicKey,
      privateKey,
      orgId,
      webhookRoute,
      webhookSecret
    },
  },
  {
    id: "/Public/Domain/Create",
    type: "object",
    properties: {
      domain,
      description,
      publicKey,
      privateKey,
      webhookRoute
    },
    required: ["domain", "description"],
  },
  {
    id: "/Public/Domain/Update",
    type: "object",
    properties: {
      description,
      publicKey,
      privateKey,
      webhookRoute
    },
  },
];
